<template>
  <main class="page-not-found">
    <b-container fluid class="full-width">
      <b-row align-v="center" class="d-flex align-items-center">
        <b-col>
          <b-container class="not-found-container-control">
            <div class="box-wrapper">
              <div class="box-outer">
                <div class="box-inner">
                  <b-row>
                    <b-col>
                      <div class="title-wrapper">
                        <h1 class="not-found-title">404 - Siden blev ikke fundet</h1>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row align-v="center" align-h="center">
                    <b-col>
                      <b-row>
                        <b-col>
                          <h3 class="not-found-undertitle">
                            Siden du prøvede at tilgå findes desværre ikke.
                          </h3>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col>
                          <h3 class="not-found-undertitle">
                            Gå til
                            <router-link :to="{ name: 'Home' }"
                              >forsiden</router-link
                            >
                          </h3>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style lang="scss" scoped>
.page-not-found {
  padding: 10px;

  .not-found-container-control {
    max-width: 100%;
  }

  .box-wrapper {
    height: 100%;

    .box-outer {
      box-shadow: 1px 2px 5px #888888;
      -webkit-box-shadow: 1px 2px 5px #888888; 
      padding: 10px;
      border-top: solid 5px $primary;
      background-color: $secondary;
      border-radius: 2px;
      margin: 10px 0;
      position: relative;
      height: 70vh;
      max-width: 100%;

      .box-inner {
        max-width: 100%;

        .title-wrapper {
          border-bottom: $border-header;
          .not-found-title {
            text-align: center;
            margin: 10px;
          }
        }
        .not-found-undertitle {
          text-align: center;
          margin-top: 30px;

          a {
            color: $primary;
          }
        }
      }
    }
  }
}

@media (min-width: 425px) {
  .box-outer {
    height: 45vh !important;
  }
}

@media (min-width: 1024px) {
  .box-outer {
    height: 45vh !important;
  }

  .not-found-container-control {
    max-width: $app-width !important;
  }
}
</style>